"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _HiddenMeasure = _interopRequireDefault(require("../layout/utils/HiddenMeasure"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _memoWithDisplayName = _interopRequireDefault(require("../utils/memoWithDisplayName"));

var _Overflows = require("../utils/Overflows");

var _decorators = require("../utils/propTypes/decorators");

var _Timers = require("../utils/Timers");

var UITruncateString = (0, _memoWithDisplayName.default)('UITruncateString', function (props) {
  var children = props.children,
      className = props.className,
      fixedChildren = props.fixedChildren,
      innerClassName = props.innerClassName,
      matchContentWidth = props.matchContentWidth,
      maxWidth = props.maxWidth,
      onTruncatedChange = props.onTruncatedChange,
      placement = props.placement,
      reverse = props.reverse,
      tooltip = props.tooltip,
      useFlex = props.useFlex,
      open = props.open,
      onOpenChange = props.onOpenChange,
      defaultOpen = props.defaultOpen,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "className", "fixedChildren", "innerClassName", "matchContentWidth", "maxWidth", "onTruncatedChange", "placement", "reverse", "tooltip", "useFlex", "open", "onOpenChange", "defaultOpen"]);

  var _useState = (0, _react.useState)(undefined),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      contentWidth = _useState2[0],
      setContentWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isTruncated = _useState4[0],
      setIsTruncated = _useState4[1];

  var wrapperRef = (0, _react.useRef)(null);
  var measureRef = (0, _react.useRef)(null);
  var tailRef = (0, _react.useRef)(null); // Workaround for a truly bizarre Safari bug (#5825); still replicable as of Safari 13.0.5

  var keyRef = (0, _react.useRef)(0);
  var hasMaxWidth = maxWidth != null;
  var hasMaxWidthRef = (0, _react.useRef)(hasMaxWidth);

  if (hasMaxWidthRef.current !== hasMaxWidth) {
    keyRef.current += 1;
    hasMaxWidthRef.current = hasMaxWidth;
  }

  var key = keyRef.current;

  var updateTruncatedState = function updateTruncatedState() {
    var wrapperEl = wrapperRef.current;
    var tailEl = tailRef.current;

    if (matchContentWidth) {
      var measureEl = (0, _reactDom.findDOMNode)(measureRef.current);
      setContentWidth(measureEl.clientWidth + 1);
    }

    var newIsTruncated = reverse ? (0, _Overflows.overflowsX)(tailEl, wrapperEl) : (0, _Overflows.overflowsX)(wrapperEl);

    if (newIsTruncated !== isTruncated) {
      setIsTruncated(newIsTruncated);
      if (onTruncatedChange) onTruncatedChange((0, _SyntheticEvent.default)(newIsTruncated));
    }
  }; // Using a scheduler callback ensures that measurement is batched, preventing extra layout costs


  var delayTimeoutRef = (0, _react.useRef)(null);

  var delayedUpdateTruncatedState = function delayedUpdateTruncatedState() {
    (0, _Timers.cancelSchedulerCallback)(delayTimeoutRef.current);
    delayTimeoutRef.current = (0, _Timers.requestSchedulerCallback)(updateTruncatedState);
  }; // Add mount/unmount behavior


  (0, _react.useEffect)(function () {
    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(delayedUpdateTruncatedState);
      resizeObserver.observe(wrapperRef.current);
      return function () {
        (0, _Timers.cancelSchedulerCallback)(delayTimeoutRef.current);
        resizeObserver.disconnect();
      };
    } else {
      updateTruncatedState();
      addEventListener('resize', delayedUpdateTruncatedState);
      return function () {
        removeEventListener('resize', delayedUpdateTruncatedState);
      };
    }
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  // When maxWidth is set, we need to set maxWidth on both the outer container and the inner
  // wrapper. We also need to set width to "unset" (if we aren't using matchContentWidth) in
  // order to prevent the table column from collapsing to 0 due to the `width: 100%` rule.

  var computedMaxWidth = maxWidth && contentWidth ? Math.min(maxWidth, contentWidth) : maxWidth || contentWidth;
  var style = computedMaxWidth ? {
    maxWidth: computedMaxWidth,
    width: maxWidth ? 'unset' : undefined
  } : undefined;
  var tailClassName = 'private-truncated-string__reverse__tail' + (isTruncated ? " is-truncated" : "");
  var renderedContent = reverse ? _react.default.createElement("span", {
    className: "private-truncated-string__reverse"
  }, isTruncated && _react.default.createElement("span", {
    className: "private-truncated-string__reverse__ellipse"
  }, "\u2026"), _react.default.createElement("span", {
    className: tailClassName
  }, _react.default.createElement("span", {
    className: "private-truncated-string__reverse__content",
    ref: tailRef
  }, children))) : _react.default.createElement("span", null, children);
  var computedTooltip = tooltip === true ? children : tooltip;
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UITooltip.default, {
    open: open,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange,
    disabled: isTruncated === false,
    placement: placement,
    title: computedTooltip
  }, _react.default.createElement("span", Object.assign({}, rest, {
    className: (0, _classnames.default)('private-truncated-string', className, useFlex && 'private-truncated-string--is-flex', Boolean(isTruncated && computedTooltip) && 'private-truncated-string--has-tooltip'),
    "data-content": true,
    key: key,
    style: style
  }), _react.default.createElement("span", {
    className: (0, _classnames.default)('private-truncated-string__inner', innerClassName),
    ref: wrapperRef,
    style: style
  }, renderedContent), fixedChildren)), matchContentWidth && _react.default.createElement(_HiddenMeasure.default, {
    ref: measureRef
  }, children));
});
UITruncateString.propTypes = {
  children: _propTypes.default.node.isRequired,
  fixedChildren: _propTypes.default.node,
  innerClassName: _propTypes.default.string,
  matchContentWidth: _propTypes.default.bool.isRequired,
  maxWidth: _propTypes.default.number,
  onTruncatedChange: (0, _decorators.hidden)(_propTypes.default.func),
  open: _UITooltip.default.propTypes.open,
  defaultOpen: _UITooltip.default.propTypes.defaultOpen,
  onOpenChange: _UITooltip.default.propTypes.onOpenChange,
  placement: _UITooltip.default.propTypes.placement,
  reverse: _propTypes.default.bool.isRequired,
  tooltip: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.node, _propTypes.default.string]).isRequired,
  useFlex: _propTypes.default.bool.isRequired
};
UITruncateString.defaultProps = {
  defaultOpen: _UITooltip.default.defaultProps.defaultOpen,
  placement: _UITooltip.default.defaultProps.placement,
  reverse: false,
  tooltip: true,
  matchContentWidth: false,
  useFlex: false
};
var _default = UITruncateString;
exports.default = _default;
module.exports = exports.default;